<template>
    <component :is="currentView" />
</template>

<script setup>
import { computed, ref, defineAsyncComponent } from "vue";
import HomeView from "./views/HomeView.vue";
import GameLoading from './workspace/components/GameLoading.vue';
const WorkspaceView = defineAsyncComponent({loader:() => import("./workspace/WorkspaceView.vue"),loadingComponent:GameLoading,delay:0});
import SSOView from "./views/SSOView.vue";
import FacilitatorView from "./views/FacilitatorView.vue";

const path = ref(window.location.pathname);

const currentView = computed(() => {
    if (path.value === "/workspace/sso") return SSOView;
    if (path.value === "/workspace" || path.value.startsWith("/workspace/")) return WorkspaceView;
    // 简单路由逻辑
    // 如果路径以 /sso 开头，则显示 SSO 组件
    if (path.value.startsWith("/sso")) {
        return SSOView;
    }
    // /facilitator/:seminarId 讲师页（苏格拉底问答收集视图）
    if (path.value.startsWith("/facilitator/")) {
        return FacilitatorView;
    }
    // 默认显示主页
    return HomeView;
});
</script>

<style>
/* 全局样式 */
body,
html {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
        "Helvetica Neue", Arial, sans-serif;
}
</style>
